import { createSvgIcon } from '@mui/material';

const IconEditNote = createSvgIcon(
  <>
    <path d="M5 3H15V5H5V19H11V21H5C3.895 21 3 20.105 3 19V5C3 3.895 3.895 3 5 3Z" />
    <path d="M21.707 6.293C22.098 5.902 22.098 5.269 21.707 4.879L19.121 2.293C18.73 1.902 18.097 1.902 17.707 2.293L10 10V14H14L21.707 6.293Z" />
    <path d="M13 17H21V19H13V17Z" />
    <path d="M15 13H23V15H15V13Z" />
  </>,
  'edit_note'
);

export default IconEditNote;
